<div *ngIf="!generatePnr" class="col-md-12 row " [style]="isActive('/app/insurancelist')?('background-color: #06497286; padding-bottom: 70px;min-width: 1300px;'):isActive('/app/insurancelist')?('background-color: transparent; padding-bottom: 70px;min-width: 1300px;'):isActive('/app/flight-intl-list')?('background-color: transparent; padding-bottom: 70px;min-width: 1300px;'):'background-color: transparent; padding-bottom: 50px;min-width: 1200px;' " >
    <div class="col-md-12" *ngIf="!isActive('/app/insurancelist')&&!isActive('/app/create-manual-cart')&&!isActive('/app/flight-intl-list')">

    <div class="outside-container  mainDiv" >

        <div class="box-container col-md-8"  style="min-width: 700px;">

                <div class="container "  >
  <app-booking-menu-list></app-booking-menu-list>
  </div> 
 </div>
</div>
</div>


  
  <div class="col-md-12 " >
    
      <div class="outside-container " [style]="isActive('/app/flight-intl-list')?('padding-top: 0; margin-top: -25px;'):isActive('/app/insurancelist')?('padding-top: 0; margin-top: -25px;'):isActive('/app/insurancelist')?('padding-top: 0; margin-top: -25px;'):isActive('/app/flight-intl-list')?('padding-top: 0; margin-top: -25px;'):''">

        <div class="box-container design" style="padding-bottom: 30px;">

                  <div class="container">
                    
                    
                      <br>
                      <br>

                      <div class="row col-md-12 ">
                        <!-- <form *ngIf="!isActive('/app/insurancelist')" [formGroup]="searchFg" class="col-md-6" action="">
                       
                        <mat-radio-group color="primary" aria-label="Select an option" (change)="onMenuChange($event)"  formControlName="menu">
                            <mat-radio-button  value="I">International</mat-radio-button>
                            <mat-radio-button  value="D">Domestic</mat-radio-button>

                          </mat-radio-group>
                          
                         
                    </form> -->

                    
                          <div class="col-md-6">
                              <div  *ngIf="selectedDetail" class="card shadow col-md-3" [style]="isActive('/app/flight-intl-list')?('height:300px; position: absolute ; right:12%;top:12%; z-index: 2;min-width:350px ;'):isActive('/app/insurancelist')?('height:300px; position: absolute ; right:12%;top:12%; z-index: 2;min-width:350px ;'):isActive('/app/insurancelist')?(' height:300px; position: absolute ; right:12%;top:12%; z-index: 2;min-width:350px ;'):'height:300px; position: absolute ; right:12%;top:36%; z-index: 2;min-width:350px ;'" >
                                          <div>
                                          <button type="button" class="close" data-dismiss="modal" (click)="closeDetail()">&times;</button>
                                          </div>
                                          <div class="row col-md-12 mt-2 d-flex justify-content-center">
                                              <div class="col-md-4 bold d-flex justify-content-start"  >Persons </div>
                                              <div class="col-md-2 " >
                                              <button (click)="decrement()" class="circle-button"> <span class="plus-icon pb-1">-</span></button>
                                              </div >{{ currentNumber }}
                                              <div class="col-md-2">
                                              <button (click)="increment()" class="circle-button">
                                              <span class="plus-icon pb-1">+</span>
                                              </button>
                                              </div> 
                                          </div>
                                    <div class="mt-4 d-flex justify-content-center" >
                                          <div class="col-md-10 row ">
                                            <div class="col-md-6 mt-2" *ngFor="let item of dobArray ;let i=index">
                                                <mat-label class="bold d-flex justify-content-start" style="text-align: start;">DOB <small>(Person {{i+1}})</small></mat-label>
                                                <input type="date" [max]="max" [(ngModel)]="item.dob" class="form-control">
                                              
                                            </div>
                                          </div>  
                                        </div>                                                                                 
                              </div>
                      </div>
                      </div>
                      <div   [class]="!isActive('/app/flight-intl-list')?('mt-2  col-md-12 d-flex justify-content-center'):!isActive('/app/insurancelist')?('mt-2  col-md-12 d-flex justify-content-center'):!isActive('/app/insurancelist')?('mt-2  col-md-12 d-flex justify-content-center'):'mt-2 row col-md-12'" style="padding-left:12px ;">

                          <div  class="col-md-10 border "  [style]="showOneWay?('display:block;border-radius: 4px; padding: 4px;background-color:white'):'display:none;'&&showReturn?('display:block;border-radius: 4px; padding: 4px;background-color:white'):'display:none;'">
                                  <form [formGroup]="searchFg"  class="row">  

                                    <!-- <div  style="border-right:1px solid #DEE2E6 ;text-align: left;" class="col-md-2">
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">TRIP TYPE</mat-label>
                                            <mat-select  name="menu" (selectionChange)="onMenuChange($event)" formControlName="menu">
                                              <mat-option class="mat-primary" value="I">International</mat-option>
                                              <mat-option class="mat-primary" value="D">Domestic</mat-option>
                                            </mat-select>

                                    </div> -->
                                      <div class="col-md-2 "   style="border-right:1px solid #DEE2E6 ;text-align: left;" >
                                  
                                          <mat-label class="col-md-12 bold" style="color:#007bff ;">Source</mat-label>
                                          <mat-select  name="menu"  style="border-bottom: 1px solid grey;font-size: 18px;" (selectionChange)="sourceChange()" formControlName="source">
                                            <mat-option class="mat-primary" value="nivabupa">Nivabupa</mat-option>
                                          </mat-select>
                          
                                      </div>
                  
                                      <div   class="col-md-2 " style="border-right:1px solid #DEE2E6 ;text-align: left;"  >
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">Category</mat-label>
                                        <mat-select  name="menu" style="border-bottom: 1px solid grey;font-size: 18px;" formControlName="geography">
                                          <!-- <mat-option class="mat-primary" value="DOM">Domestic</mat-option>
                                          <mat-option class="mat-primary" value="APAC">APAC</mat-option> -->
                                          <mat-option class="mat-primary" *ngFor="let item of geographyList" [value]="item.key">{{item.display}}</mat-option>

                                        </mat-select>

                                      
                                        
                                      </div>
                                      <div class="col-md-2 " style="border-right:1px solid #DEE2E6 ;text-align: left;"  >
                                        <!-- <mat-label *ngIf="!isActive('/app/insurancelist') "  class="col-md-12 bold" style="color:#007bff ;">Category</mat-label>
                                        <mat-select *ngIf="!isActive('/app/insurancelist') " name="menu"  style="border-bottom: 1px solid grey;font-size: 18px;" formControlName="geography">
                                          <mat-option class="mat-primary" value="DOM">Domestic</mat-option>
                                          <mat-option class="mat-primary" value="APAC">APAC</mat-option>

                                        </mat-select> -->

                                        <mat-label  class="col-md-12 bold " style="color:#007bff ;padding-top: 4px;">TRIP TYPE</mat-label>
                                        <mat-select    name="menu"  style="border-bottom: 1px solid grey;font-size: 18px;" formControlName="tripType">
                                          <mat-option class="mat-primary" *ngFor="let item of tripTypeList" [value]="item.key">{{item.display}}</mat-option>

                                          <!-- <mat-option class="mat-primary" value="multiTrip">Annual Multi Trip</mat-option> -->

                                        </mat-select>
                                         
                                      </div>
                              
                                      <div class="col-md-2" style="border-right:1px solid #DEE2E6 ;text-align: left;cursor: pointer" (click)="pickers.open()">
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">Start Date</mat-label>
                                              <input class="mainbox"  style="color: transparent;padding: 0;margin: 0; font-size: 1px;" formControlName="requestedDate" readonly [min]="minData" [matDatepicker]="pickers"  (dateChange)="onOneWayDate()">
                                            <!-- <div class="col-md-12" *ngIf="!isActive('/app/insurancelist')&&!isActive('/app/flight-intl-list')">
                                              <span class=" bold" [style]="!isActive('/app/insurancelist')?('font-size: 35px;'):!isActive('/app/insurancelist')?('font-size: 35px;'):!isActive('/app/flight-intl-list')?('font-size:35px'):'font-size: 20px;'">{{departureTime[0]}}</span>&nbsp;&nbsp;<span  [style]="!isActive('/app/insurancelist')?('font-size: 23px;'):'font-size: 18px;'">{{departureTime[1]}}</span><span  [style]="!isActive('/app/insurancelist')?('font-size: 25px;'):'font-size: 20px;'">{{departureTime[2]?("'"+departureTime[2]):''}}</span>
                                              <br><span class=" bold" style="font-size: 15px; ">{{departureTime[3]}}</span>
                                            </div> -->
                                            <div >
                                                <span class="bold"> {{departureTime}}</span> 
                                               </div>
                                              <mat-datepicker #pickers ></mat-datepicker>
                                      </div>
                                  
                                      <div class="col-md-2" (click)="picker.open()" style="border-right:1px solid #DEE2E6 ;text-align: left;cursor: pointer">
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">End Date</mat-label>

                                          <input   style="color: transparent;padding: 0;margin: 0; font-size: 1px;" class="mainbox" readonly [min]="searchFg.value.requestedDate" [matDatepicker]="picker" formControlName="returnDate" (dateChange)="onRChangeDate()">
                                          <!-- <div *ngIf="arrivelTime && !isActive('/app/insurancelist')&&!isActive('/app/flight-intl-list')" class="col-md-12">
                                            <span  class=" bold" [style]="!isActive('/app/insurancelist')?('font-size: 35px;'):!isActive('/app/insurancelist')?('font-size: 35px;'):!isActive('/app/flight-intl-list')?('font-size:35px'):'font-size: 20px;'">{{arrivelTime[0]}}</span>&nbsp;&nbsp;<span  [style]="!isActive('/app/insurancelist')?('font-size: 23px;'):'font-size: 18px;'">{{arrivelTime[1]}}</span><span  [style]="!isActive('/app/insurancelist')?('font-size: 25px;'):'font-size: 20px;'">{{arrivelTime[2]?("'"+arrivelTime[2]):''}}</span>
                                            <br><span class=" bold" style="font-size: 15px; ">{{arrivelTime[3]}}</span>
                                          </div> -->
                                          <div >
                                           <span class="bold"> {{arrivelTime}}</span> 
                                          </div>
                                          <div class="bold" *ngIf="!arrivelTime" style="font-size: 12px;">Tap&nbsp;to&nbsp;add&nbsp;a&nbsp;return&nbsp;date</div>
                                          <!-- <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle> -->
                                          <mat-datepicker #picker></mat-datepicker>
                                          
                                      </div>
                                      <div class="col-md-2"  style="border-right:1px solid #DEE2E6 ;text-align: left;cursor: pointer;"  (click)="SelectDetail()">
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">Passengers</mat-label>
                                        <span class="d-flex justify-content-start pointer" style="position:relative" > <mat-icon >person</mat-icon>{{ currentNumber}}</span>

                                      </div>
                                      <!-- <div class="col-md-2"  *ngIf="!isActive('/app/insurancelist') "  >
                                        <button style="width: 100%;height:20px; " mat-raised-button color="accent" (click)="searchFlight()" >
                                        <span class="bold" style="font-size:xx-large;">SEARCH</span>
                                        </button>  
                                      </div>   -->
                                      <!-- <div class="col-md-2"  *ngIf="isActive('/app/create-manual-cart')"  >
                                        <button style="width: 100%;height:20px; "  mat-raised-button color="accent" (click)="searchFlight()" [disabled]="!userName">
                                        <span class="bold" style="font-size:xx-large;">ADD</span>
                                        </button>  
                                      </div>   -->
                                    
                                  </form>           
                              </div>
                             
                              <div >
                                <button style="width: 100%; border-radius: 10px; " mat-raised-button color="accent" (click)="searchFlight()" >
                                <span class="bold" style="font-size: xx-large;">SEARCH</span>
                                </button>  
                              </div>  
                      </div>
                  
                     <div *ngIf="showPnrRetrieval">
                        <app-manual-cart></app-manual-cart>

                     </div>

                   
                    </div> 

              </div> 
             
      </div>
  </div>
</div>


<div *ngIf="generatePnr" class="col-md-12 " >
    <app-generate-pnr (myOutput)="GetChildData()" ></app-generate-pnr>
</div>
<span *ngIf="!isActive('/app/create-manual-cart')">
<!-- <app-offers *ngIf=" !isActive('/app/insurancelist')&& !isActive('/app/insurancelist')"></app-offers> -->
</span>